var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkIcon = function SvgExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.33331L6.33337 9.66665M6.33337 2.99998H3.00004C2.55801 2.99998 2.13409 3.17557 1.82153 3.48813C1.50897 3.8007 1.33337 4.22462 1.33337 4.66665V13C1.33337 13.442 1.50897 13.8659 1.82153 14.1785C2.13409 14.4911 2.55801 14.6666 3.00004 14.6666H11.3334C11.7754 14.6666 12.1993 14.4911 12.5119 14.1785C12.8244 13.8659 13 13.442 13 13V9.66665L6.33337 2.99998ZM9.66671 1.33331H14.6667H9.66671ZM14.6667 1.33331V6.33331V1.33331Z",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgExternalLinkIcon;